import { AbstractSource } from "../../../../base/infrastructure/drawing";
import { IContentSource } from "../../../../base/domain/drawing";

export class EditableFormatArchiveReferenceFileSource extends AbstractSource {
  constructor(getToken: () => string, public formatId: number, public fileId: number, public formatArchiveId: number) {
    super(getToken);
  }

  protected getSource(): string {
    const url = "/api/format-editor/format/" + this.formatId + "/reference/" + this.fileId + "/" + this.formatArchiveId + "?token=" + this.token;
    console.debug("[Source] " + url);
    return url;
  }

  public clone(): IContentSource {
    return new EditableFormatArchiveReferenceFileSource(
      this._getToken,
      this.formatId,
      this.fileId,
      this.formatArchiveId,
    );
  }
}
